import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;
const Blockly = GlobalImport.getBlockly();

export class AnyLibrary extends AbstractBlock {
  constructor() {
    super('any_lib', t.to('汎用ライブラリー', 'general_lib'));
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setElementWithSubBlockShape(block);
    ColorSettings.setAnyColor(block);
    ShapeSettings.setTitleField(block, t.to('汎用ライブラリ', 'general_lib'));

    const path = new Blockly.FieldTextInput('');
    block
      .appendDummyInput()
      .appendField(t.to(`ライブラリパス`, 'lib_path') + '：')
      .appendField(path, 'path');
    ShapeSettings.addAttributeInput(block);
  }

  generateStaticHTMLCode(block: BlockType): string {
    const path = CodeSetting.getFieldValue(block, 'path');
    // console.log(path);
    const src = `<script type="text/javascript" src="${path}"></script>`;
    return src;
  }
}
